import React from 'react'
import {TooltipProps} from 'recharts'

interface PayloadData {
  label: string
  count: number
  percentage?: number
}

export const CustomCartesianGridTooltip: React.FC<TooltipProps<number, string> & {showCount?: boolean}> = ({active, showCount = false, payload}) => {
  if (!active || !payload?.length) return null

  const {label, count, percentage} = payload[0].payload as PayloadData

  return (
    <div
      style={{
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: 6,
        padding: '12px 16px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.08)',
        fontSize: 14,
        color: '#333',
        minWidth: 160,
      }}
    >
      <div style={{fontWeight: 600, marginBottom: 4}}>{label}</div>
      {showCount && (
        <div>
          <span style={{fontWeight: 500}}>Antal:</span>
          {count}
        </div>
      )}
      {percentage && (
        <div>
          <span style={{fontWeight: 500}}>Andel:</span>
          {(percentage * 100).toFixed(1)}%
        </div>
      )}
    </div>
  )
}
